import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { readLinkToken, clearLinkToken } from "@/lib/linkToken";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = readLinkToken("/verify-email");
    if (!token) { setState("error"); setMsg("Missing verification token."); return; }
    api.post("/onboarding/email/verify", { token })
      .then(async () => { clearLinkToken("/verify-email"); setState("ok"); await refresh(); setTimeout(() => navigate("/onboarding"), 1500); })
      .catch((err) => { setState("error"); setMsg(formatApiError(err.response?.data?.detail) || "Verification failed."); });
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] px-4" data-testid="verify-email-page">
      <div className="bg-white border border-slate-200 rounded-xl p-8 max-w-md w-full text-center">
        {state === "loading" && <><Loader2 className="animate-spin mx-auto text-slate-400" size={32} /><p className="mt-4 text-slate-600">Verifying your email…</p></>}
        {state === "ok" && <><CheckCircle2 className="mx-auto text-emerald-500" size={40} /><h1 className="mt-4 font-heading text-xl font-bold text-[#0A0F1C]">Email verified</h1><p className="mt-1 text-slate-500 text-sm">Redirecting you to continue onboarding…</p></>}
        {state === "error" && <><XCircle className="mx-auto text-red-500" size={40} /><h1 className="mt-4 font-heading text-xl font-bold text-[#0A0F1C]">Verification failed</h1><p className="mt-1 text-slate-500 text-sm" data-testid="verify-email-error">{msg}</p><Link to="/onboarding" className="mt-4 inline-block text-[#2563EB] font-medium text-sm">Request a new link</Link></>}
      </div>
    </div>
  );
}
